import { render, staticRenderFns } from "./TenantSwitchField.vue?vue&type=template&id=0553141f&scoped=true"
import script from "./TenantSwitchField.vue?vue&type=script&lang=ts"
export * from "./TenantSwitchField.vue?vue&type=script&lang=ts"
import style0 from "./TenantSwitchField.vue?vue&type=style&index=0&id=0553141f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0553141f",
  null
  
)

export default component.exports